import RACES from './RACES'
import entityHelper from '../utils/entityHelper'

const { createBaseUnit } = entityHelper

const STAGES = {
    '1-1': {
        ID: '1-1',
        title: 'The Beginning (1-1)',
        location: [
            [
                { player: true },
                {
                    story: [
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: 'Halt, who goes there?!',
                        },
                        {
                            avatar: '❓',
                            name: '❔',
                            side: 'right',
                            text: '*sounds of combat are coming from the woods*',
                        },
                        {
                            avatar: '❓',
                            name: '*female voice*',
                            side: 'right',
                            text: 'GET OFF ME, YA DIRTY BARSTUD!!!',
                        },
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: 'Damn, gotta hurry!',
                        },
                    ],
                },
                { banner: 'Prelude' },
                {
                    enemies: [
                        createBaseUnit('bad', RACES.GOBLIN.ID, 'Goblin A', 'male'),
                    ],
                },
                { battle: true },
                {
                    enemies: [
                        createBaseUnit('bad', RACES.HUMAN.ID, '???', 'female'),
                    ],
                },
                {
                    story: [
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: 'Are you ok?',
                        },
                        {
                            avatar: '👩',
                            name: '❔',
                            side: 'right',
                            text: 'Don\'t you think for one second that I\'m gonna smooch ya for that.',
                        },
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: '. . .',
                        },
                        {
                            avatar: '👩',
                            name: '❔',
                            side: 'right',
                            text: 'I\'m not some damsel in distress that needs saving. I can hold my own in battle!',
                        },
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: '. . .',
                        },
                        {
                            avatar: '👩',
                            name: '❔',
                            side: 'right',
                            text: 'I was about to whoop his sorry buttock when you showed up and stole the show...',
                        },
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: 'Yeah, I could see that... I just wanted to lend a hand. I mean, it\'s not like we get exp for killing random enemies, right?!',
                        },
                        {
                            avatar: '👩',
                            name: 'Olga',
                            side: 'right',
                            text: 'Yeah, right... whatev. I\'m Olga. Thanks for the "help".',
                        },
                    ],
                },
            ],
        ],
        reward: {
            first: ['CRYST_10', 'HERO_XY002', 'GOLD_100', 'WEAPON_1', 'ARMOR_1'],
            repeat: ['WEAPON_1', 'GOLD_15'],
            lost: ['GOLD_5'],
        },
    },
    '1-2': {
        ID: '1-2',
        title: 'First Waves (1-2)',
        location: [
            [
                {
                    enemies: [
                        createBaseUnit('bad', RACES.GOBLIN.ID, 'Goblin A', 'male'),
                        createBaseUnit('bad', RACES.GOBLIN.ID, 'Goblin B', 'male'),
                    ],
                },
                { player: true },
                {
                    story: [
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: 'Wanna help *me* out this time?',
                        },
                        {
                            avatar: '👩',
                            name: 'Olga',
                            side: 'right',
                            text: 'You sure look like you need help, that\'s for sure.',
                        },
                    ],
                },
                { banner: 'Wave 1/2' },
                { battle: true },
            ],
            [
                {
                    story: [
                        {
                            avatar: '👩',
                            name: 'Olga',
                            side: 'right',
                            text: 'There\'s one more. That\'s a big one.',
                        },
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: 'No problem, we can handle that! ... *KIAI!*',
                        },
                        {
                            avatar: '👩',
                            name: 'Olga',
                            side: 'right',
                            text: '. . .',
                        },
                    ],
                },
                {
                    enemies: [
                        createBaseUnit('bad', RACES.ORC.ID, 'Orc A', 'male'),
                    ],
                },
                { banner: 'Wave 2/2' },
                { battle: true },
                {
                    story: [
                        {
                            avatar: '👩',
                            name: 'Olga',
                            side: 'right',
                            text: 'You\'re not *that* bad, after all. Mind if I tag along for now?',
                        },
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: '. . .',
                        },
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: 'Yeah, why not. The more, the merrier. I\'m just headed to town anyway.',
                        },
                        {
                            avatar: '👩',
                            name: 'Olga',
                            side: 'right',
                            text: 'Great. And maybe we pass a river and you can do something about that smell of yours.',
                        },
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: '. . .',
                        },
                    ],
                },
            ],
        ],
        reward: {
            first: ['CRYST_10', 'GOLD_200', 'WEAPON_1', 'ARMOR_1'],
            repeat: ['ARMOR_1', 'GOLD_20'],
            lost: ['GOLD_10'],
        },
    },
    '1-3': {
        ID: '1-3',
        location: [
            [
                {
                    enemies: [
                        createBaseUnit('bad', RACES.ORC.ID, 'Orc A', 'male'),
                        createBaseUnit('bad', RACES.ORC.ID, 'Orc B', 'male'),
                    ],
                },
                { player: true },
                { banner: 'GUARDS!' },
                { battle: true },
                {
                    enemies: [
                        createBaseUnit('bad', RACES.ELF.ID, 'Tinkle', 'male'),
                    ],
                },
                {
                    story: [
                        {
                            avatar: '🧝‍♂️',
                            name: 'Tinkle',
                            side: 'right',
                            text: 'My name is Tinkle. You seem to be totally trustworthy and you killed my captors. I owe you my life!',
                        },
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: '. . .',
                        },
                        {
                            avatar: '👩',
                            name: 'Olga',
                            side: 'left',
                            text: 'Ooooookay. So now you want to follow us and do our every bidding?',
                        },
                        {
                            avatar: '🧝‍♂️',
                            name: 'Tinkle',
                            side: 'right',
                            text: 'If that is your command, I will do exactly that. No questions asked.',
                        },
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: '. . .',
                        },
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: 'I\'m out, this is bull!',
                        },
                    ],
                },
            ],
        ],
        reward: {
            first: ['HERO_XY003', 'CRYST_10', 'SET_FIRE_1', 'SET_EARTH_1', 'WEAPON_1', 'ARMOR_1', 'WEAPON_2', 'ARMOR_2', 'GOLD_300'],
            repeat: ['WEAPON_1', 'ARMOR_1', 'GOLD_30'],
            lost: ['GOLD_15'],
        },
    },
    '1-4': {
        ID: '1-4',
        title: 'BOSS STAGE',
        location: [
            [
                { player: true },
                {
                    enemies: [
                        createBaseUnit('bad', RACES.GOBLIN.ID, 'Goblin A', 'male'),
                        createBaseUnit('bad', RACES.GOBLIN.ID, 'Goblin B', 'male'),
                    ],
                },
                { banner: 'Wave 1/3' },
                { battle: true },
            ],
            [
                { banner: 'Wave 2/3' },
                {
                    enemies: [
                        createBaseUnit('bad', RACES.ORC.ID, 'Orc A', 'male'),
                    ],
                },
                { battle: true },
            ],
            [
                { banner: 'The Orc Chieftain (3/3)' },
                {
                    enemies: [
                        createBaseUnit('bad', RACES.ORC.ID, 'Orc Chieftain', 'male', { timeframe: -10, stats: { hp: 25, attack: 15, rate: -5 } }),
                        createBaseUnit('bad', RACES.GOBLIN.ID, 'Goblin A', 'male'),
                        createBaseUnit('bad', RACES.GOBLIN.ID, 'Goblin B', 'male'),
                        createBaseUnit('bad', RACES.GOBLIN.ID, 'Goblin C', 'male'),
                        createBaseUnit('bad', RACES.GOBLIN.ID, 'Goblin D', 'male'),
                    ],
                },
                { battle: true },
            ],
        ],
        reward: {
            first: ['CRYST_50', 'WEAPON_2', 'ARMOR_2', 'GOLD_1200'],
            repeat: ['WEAPON_2', 'ARMOR_2', 'GOLD_120'],
            lost: ['WEAPON_1', 'ARMOR_1', 'GOLD_50'],
        },
    },
    '2-1': {
        ID: '2-1',
        location: [
            [
                { player: true },
                {
                    enemies: [
                        createBaseUnit('bad', RACES.SKELETON.ID, 'Skeleton A', 'male'),
                        createBaseUnit('bad', RACES.SKELETON.ID, 'Skeleton B', 'male'),
                        createBaseUnit('bad', RACES.SKELETON.ID, 'Skeleton C', 'male'),
                    ],
                },
                { banner: 'A new enemy' },
                { battle: true },
                { banner: 'The Wall' },
                {
                    story: [
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: 'There seems to be an invisible wall in front of us!',
                        },
                        {
                            avatar: '👩',
                            name: 'Olga',
                            side: 'right',
                            text: 'That\'s funny... is that some sort of evil spell?',
                        },
                        {
                            avatar: '🧝',
                            name: 'Tinkle',
                            side: 'right',
                            text: 'I think I can debunk this. It seems, the dev was lazy and didn\'t create enough levels for us to clear.',
                        },
                        {
                            avatar: '👨',
                            name: 'Hans',
                            side: 'left',
                            text: 'Friend, you are talking in strange tongues. I hear the words but the meaning eludes me!',
                        },
                        {
                            avatar: '🧝',
                            name: 'Tinkle',
                            side: 'right',
                            text: 'Ok, in more simple words: We can\'t continue for now and need to wait till the way is clear again. Let\'s just kill some more undead for now and try again later.',
                        },
                    ],
                },
            ],
        ],
        reward: {
            first: ['CRYST_10', 'GOLD_300', 'WEAPON_2'],
            repeat: ['WEAPON_2', 'GOLD_30'],
            lost: ['GOLD_15'],
        },
    },
}

export default STAGES
